
import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


import { useSelector,useDispatch } from 'react-redux';



const Odors = () => {
  const odors = [
    {phone:"+18322354616", time:"10/20/2022", location:"Grandville Avenue", description:"Smells fishy"},
    {phone:"+18322354616", time:"10/21/2022", location:"Grandville Avenue", description:"Smells earthy"},
    {phone:"+18322354616", time:"10/22/2022", location:"Downtown Grand Rapids", description:"It feels great today"},
    {phone:"+1616554516", time:"10/22/2022", location:"Grandville Avenue", description:"Lot of trucks idling today"}
  ]


  return (

     <React.Fragment>

     <Table size="small">
       <TableHead>
         <TableRow>
           <TableCell>Phone</TableCell>
           <TableCell>Time</TableCell>
           <TableCell>Location</TableCell>
           <TableCell>Odor Description</TableCell>


         </TableRow>
       </TableHead>
       <TableBody>
          {odors.map( ( odor ) => (

            <TableRow >
               <TableCell>{odor.phone}</TableCell>
               <TableCell>{odor.time}</TableCell>
               <TableCell>{odor.location}</TableCell>
               <TableCell>{odor.description}</TableCell>
             </TableRow>
          ))}
      </TableBody>
    </Table>
    </React.Fragment>

  );


}

export default Odors;
